var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBreasts3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 59,
  fill: "none",
  viewBox: "0 0 26 59"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M1.49 1c2.25 4.169 4.91 7.197 6.68 9.067C11.67 13.755 25 21.193 25 29.61c0 9.947-11.78 13.195-11.78 13.195s-.09 2.42-.04 4.259c.1 3.589.41 6.748.3 10.936"
})));
export default SvgBreasts3;